var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextPageTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 139,
    viewBox: "0 0 215 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0259 109.358L64.5889 104.257C17.8112 60.3689 -5.57759 38.425 1.92528 19.4625C9.42815 0.5 41.4995 0.500003 105.642 0.500005L115.844 0.500005C175.015 0.500007 204.6 0.500008 212.439 18.5496C220.278 36.5991 200.082 58.2188 159.69 101.458L154.925 106.559C135.578 127.269 125.905 137.624 113.467 138.034C101.028 138.444 90.6939 128.749 70.0259 109.358Z",
    fill: "#00CCFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.368 108.993L64.931 103.892C41.5301 81.9367 24.0204 65.5072 13.2911 52.1988C2.54641 38.8712 -1.25169 28.8509 2.39021 19.6465C6.03211 10.4421 15.6581 5.73322 32.6129 3.36551C49.5434 1.00121 73.5541 1 105.642 1.00001L115.844 1.00001C145.447 1.00001 167.592 1.00127 183.32 3.25116C199.064 5.50319 208.173 9.98132 211.981 18.7487C215.788 27.5161 212.842 37.2296 203.741 50.2715C194.648 63.3011 179.532 79.4849 159.325 101.117L154.559 106.218C144.876 116.583 137.648 124.32 131.289 129.522C124.941 134.716 119.516 137.335 113.45 137.535C107.384 137.735 101.799 135.478 95.1227 130.714C88.4346 125.942 80.7123 118.698 70.368 108.993Z",
    stroke: "#B3F0FF",
    strokeOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3_113",
    x: -1.45517,
    y: -35.5,
    width: 215.56,
    height: 173.547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0783333 0 0 0 0 0.485667 0 0 0 0 0.5875 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_113"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0276563 0 0 0 0 0.595531 0 0 0 0 0.7375 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3_113",
    result: "effect2_innerShadow_3_113"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPageTriangle);
export default __webpack_public_path__ + "static/media/next-page-triangle.20ec48fbe054d175e1f86100d33df904.svg";
export { ForwardRef as ReactComponent };